export const FEATURE_FLAG_AUTHORING_PUBLISH = "authoring-publish"
export const FEATURE_FLAG_GLOBAL_UPDATES = "authoring-global-updates"
export const FEATURE_FLAG_COMPONENT_REVIEW = "component-review"
export const FEATURE_FLAG_SCHEDULE_COMMENTARY = "schedule-commentary"
export const FEATURE_FLAG_ARCHIVE_WORK_PACKAGES = "authoring-archive-work-packages"
